module.exports = __webpack_public_path__ + "img/bluesky3100_02.8ec38d30.jpg";